import { useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import primaryComponents from "..";
import { v4 as uuidv4 } from "uuid";
import { useClickOutSide } from "../../../hooks/useClickOutside";
import { AngleDown } from "../../../assets/svgIcons";

export const MultiSelectFilter = ({
  placeholder,
  name = "",
  isRequired = false,
  label = null,
  labelStyles = {},
  labelClassNames = "",
  selectedOption = [],
  options = [],
  idKey,
  nameKey,
  isDisabled = false,
  onChange = () => {},
}) => {
  const [isActiveDropdown, setIsActiveDropdown] = useState(false);
  const [selectedItem, setSelectedItem] = useState(selectedOption || []);
  const [value, setValue] = useState("");
  const [isSelectAll, setIsSelectAll] = useState(false);
  const { inputRef } = useClickOutSide({
    close: () => {
      setIsActiveDropdown(false);
    },
  });

  const checkBoxName = `multiselect${uuidv4()}`;
  const selectAllName = useMemo(() => {
    return `selectAllName${uuidv4()}`;
  }, []);
  const selectAllId = useMemo(() => {
    return `selectAllId${uuidv4()}`;
  }, []);

  useEffect(() => {
    if (isSelectAll) {
      const selectedIds = options?.map((option) => `${option?.[idKey]}`);
      setSelectedItem(selectedIds);
    } else setSelectedItem([]);
  }, [isSelectAll]);

  return (
    <span className={styles.multiSelectFilter} ref={inputRef}>
      {label !== null && (
        <>
          <label
            htmlFor={name}
            data-testid="label"
            className={`${labelClassNames}`}
            style={{ ...labelStyles }}
          >
            {isRequired && <span className="text-danger">*</span>}
            <span>{label}</span>
          </label>
        </>
      )}
      <span
        className={`${styles.input} ${isDisabled ? styles.disbaled : ""}`}
        onClick={() => {
          if (isDisabled) return;

          setIsActiveDropdown((prev) => !prev);
          if (isActiveDropdown) setSelectedItem(selectedOption);
        }}
      >
        {selectedItem?.length ? (
          <span className={styles.count}>{selectedItem?.length}</span>
        ) : null}
        <input
          placeholder={placeholder}
          value={value}
          disabled={isDisabled}
          onChange={(e) => {
            setValue(e?.target?.value);
          }}
        />

        <AngleDown style={{ color: "#cccccc" }} />
      </span>

      <span
        className={`${styles.dropdown} ${isActiveDropdown ? styles.active : ""}`}
      >
        {options?.length ? (
          <>
            <span className={`${styles.dropdown__item} ml-auto mb-3`}>
              <primaryComponents.Checkbox
                name={selectAllName}
                id={selectAllId}
                isChecked={isSelectAll}
                onChange={() => {
                  setIsSelectAll((prev) => !prev);
                }}
              >
                <span className="mt-1 font-weight-bold">Select All</span>
              </primaryComponents.Checkbox>
            </span>
            {options
              ?.filter((option) =>
                option?.[nameKey]?.toLowerCase()?.includes(value.toLowerCase()),
              )
              ?.map((option) => {
                const optionId = option?.[idKey];

                return (
                  <span key={optionId} className={styles.dropdown__item}>
                    <primaryComponents.Checkbox
                      name={checkBoxName}
                      id={`${checkBoxName}${optionId}`}
                      isChecked={selectedItem.includes(`${optionId}`)}
                      onChange={() => {
                        setSelectedItem((prev) =>
                          prev.includes(`${optionId}`)
                            ? prev.filter((item) => `${item}` !== `${optionId}`)
                            : [...prev, `${optionId}`],
                        );
                      }}
                    >
                      <span className="mt-1">{option?.[nameKey]}</span>
                    </primaryComponents.Checkbox>
                  </span>
                );
              })}

            <span className={styles.btn}>
              <primaryComponents.Button
                classNames={"btn btn--primary smallBtn w-100"}
                onClick={() => {
                  onChange(selectedItem?.length ? selectedItem : null);
                  setIsActiveDropdown(false);
                }}
              >
                Apply
              </primaryComponents.Button>
            </span>
          </>
        ) : (
          <span className="text-center d-block my-3">Empty Options</span>
        )}
      </span>
    </span>
  );
};
